module.exports = __webpack_public_path__ + "static/media/28-10.1d40d4ff.mp3";